export { default } from './LightMontlyHistogramContainerMobile';
